export const ENTITLEMENT_LOCKED_ROW_CLASS = 'entitlement-locked-row';

// Blur radius matches EntitlementLockOverlay's full-page treatment for visual consistency.
export const entitlementLockedRowSx = {
  [`& .MuiDataGrid-row.${ENTITLEMENT_LOCKED_ROW_CLASS}`]: {
    filter: 'blur(2px)',
    pointerEvents: 'none',
    userSelect: 'none',
  },
} as const;

// Same treatment applied directly to a mobile card's `sx`, since it isn't a DataGrid row.
export const entitlementLockedCardSx = {
  filter: 'blur(4px)',
  pointerEvents: 'none',
  userSelect: 'none',
} as const;

export function isRowEntitlementLocked(
  rowsLocked: boolean,
  isBaseConfig: boolean,
): boolean {
  return rowsLocked && !isBaseConfig;
}
